
import PaymentRepository from "../domain/data/PaymentRepository";
import Payment from "../domain/entities/Payment";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIPaymentRepository implements PaymentRepository {
  private client = new AwsApiClient();

  async savePayment(payment: Payment): Promise<Payment> {
    try { 
      const response = await this.client.postExternal(`/api/payment`, payment);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getPayment(paymentId: string): Promise<Payment> {
    try {
      const response = await this.client.getExternal(
        `/api/payment/info/${paymentId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getPayments(organizationId: string): Promise<Payment[]> {
    try {
      const response = await this.client.get(
        `/api/payments/${organizationId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getPaymentsLookupsCount(
    user: User,
    lookupType: string,
    lookupValue: string,
    lookupStatus?: string,
    lookupCreationTime?: string
  ): Promise<number> {
    try {
      const requestBody: any = { lookupType, lookupValue };
      
      if (lookupStatus) {
        requestBody.lookupStatus = lookupStatus;
      }
      
      if (lookupCreationTime) {
        requestBody.lookupCreationTime = lookupCreationTime;
      }
      
      const response = await this.client.post(
        `/api/payments/lookup/count/${user.organization.id}`,
        requestBody
      );
      
      return response;
    } catch (error) {
      const message = `An error has occurred: ${error}`;
      throw new Error(message);
    }
  }

  async getPaymentsByLookupPagination(
    user: User,
    lookupType: string,
    lookupValue: string,
    pageSize: number,
    lastEvaluatedKey: Record<string, string> | null,
    existingMessageIds: string[] | null,
    lookupStatus?: string,
    lookupCreationTime?: string
  ): Promise<{ items: Payment[]; lastEvaluatedKey?: any }> {
    try {
      const requestBody: any = {
        lookupType,
        lookupValue,
        pageSize,
        lastEvaluatedKey,
        existingMessageIds,
      };

      if (lookupStatus) {
        requestBody.lookupStatus = lookupStatus;
      }

      if (lookupCreationTime) {
        requestBody.lookupCreationTime = lookupCreationTime;
      }

      const response = await this.client.post(
        `/api/payments/lookup/pagination/${user.organization.id}`,
        requestBody
      );
      
      return response;
    } catch (error) {
      throw new Error(`An error has occurred: ${error}`);
    }
  }

  async successPayment(paymentId: string): Promise<Payment> {
    try {
      const response = await this.client.postExternal(
        `/api/payment/success/${paymentId}`, null
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
